const StoryPlayerEvent = {};
export default StoryPlayerEvent;

/**
 * The StoryPlayerEvent.STORY_START constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_START</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_START
 */
StoryPlayerEvent.STORY_START = "STORY_START";
/**
 * The StoryPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_END
 */
StoryPlayerEvent.STORY_END = "STORY_END";
/**
 * The StoryPlayerEvent.STORY_NODE_UNLOCKED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the unlocked IStoryNode belongs to</td></tr>
 * <tr><td>storyNode</td><td>The unlocked IStoryNode</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_UNLOCKED
 */
StoryPlayerEvent.STORY_NODE_UNLOCKED = "STORY_NODE_UNLOCKED";
/**
 * The StoryPlayerEvent.STORY_NODE_AVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the IStoryNode that became available belongs to</td></tr>
 * <tr><td>storyNode</td><td>The IStoryNode that became available</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_AVAILABLE
 */
StoryPlayerEvent.STORY_NODE_AVAILABLE = "STORY_NODE_AVAILABLE";
/**
 * The StoryPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_UNAVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the IStoryNode that became unavailable belongs to</td></tr>
 * <tr><td>storyNode</td><td>The IStoryNode that became unavailable</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_UNAVAILABLE
 */
StoryPlayerEvent.STORY_NODE_UNAVAILABLE = "STORY_NODE_UNAVAILABLE";
/**
 * The StoryPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_COMPLETED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the IStoryNode that is completed belongs to</td></tr>
 * <tr><td>storyNode</td><td>The IStoryNode is completed available</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_COMPLETED
 */
StoryPlayerEvent.STORY_NODE_COMPLETED = "STORY_NODE_COMPLETED";
/**
 * The StoryPlayerEvent.STORY_ARC_UNLOCKED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_UNLOCKED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc that became unlocked</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_UNLOCKED
 */
StoryPlayerEvent.STORY_ARC_UNLOCKED = "STORY_ARC_UNLOCKED";
/**
 * The StoryPlayerEvent.STORY_ARC_AVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_AVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc that became available</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_AVAILABLE
 */
StoryPlayerEvent.STORY_ARC_AVAILABLE = "STORY_ARC_AVAILABLE";
/**
 * The StoryPlayerEvent.STORY_ARC_UNAVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_UNAVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc that became unavailable</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_UNAVAILABLE
 */
StoryPlayerEvent.STORY_ARC_UNAVAILABLE = "STORY_ARC_UNAVAILABLE";
/**
 * The StoryPlayerEvent.STORY_ARC_COMPLETED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_COMPLETED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc that became completed</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_COMPLETED
 */
StoryPlayerEvent.STORY_ARC_COMPLETED = "STORY_ARC_COMPLETED";